@let fieldData = field();
@let formControl = control();

@if (formControl) {
  <div class="mb-6 relative">
    <label class="block x-font-body-4 mb-2">
      <span
        [class.font-extrabold]="fieldData.isHighlighted"
        class="x-text-wf-title"
      >
        {{ fieldData.title }}
      </span>
      @if (fieldData.validation?.isRequired) {
        <span class="font-extrabold">*</span>
      }
      @if (fieldData.helpText) {
        <tui-icon
          [tuiTooltip]="fieldData.helpText"
          (click)="$event.stopPropagation(); $event.preventDefault()"
        ></tui-icon>
      }
    </label>

    <div class="space-y-2">
      @for (option of fieldData.options; track option.title) {
        <label tuiLabel class="flex items-center">
          <input
            tuiRadio
            type="radio"
            size="m"
            [formControl]="formControl"
            [value]="option.title"
          />
          <span class="x-font-body-4">{{ option.title }}</span>
        </label>
      }
    </div>

    @if (formControl.invalid && (formControl.dirty || formControl.touched)) {
      <div class="x-text-wf-error x-font-body-5 mt-1 absolute">
        @if (formControl.hasError('required')) {
          <span>Обязательное поле</span>
        }
        @if (formControl.hasError('customError')) {
          <span>Ошибка валидации</span>
        }
      </div>
    }
  </div>
}
